import { Container } from '@/features/pos/components/ProductCatalog/parts/ProductList/types'
import { ContainersQuery } from '@/features/pos/components/ProductCatalog/queries/containers'
import { transformContainer } from '@/features/pos/components/ProductCatalog/utils/categories-with-products-transforms'
import { useHandleQueryErrorWithToast } from '@/features/pos/hooks/useHandleQueryErrorWithToast'
import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

export const useContainers = (): Container[] | undefined => {
    const { data, error, loading } = useQuery(ContainersQuery)

    useHandleQueryErrorWithToast(error, loading)

    return useMemo(() => data?.containers.map(transformContainer), [data])
}
